export default __webpack_public_path__ + "static/media/seven.4510c5af.svg";